import React from 'react';
import '../stylesheets/ImageSection.scss';

export default function ImageSection(props) {
  return (
    <section className="image-section">
      <img className={` desktop ${props.classname}`} alt="pull quote" src={props.selectedImage} style={{ width: props.width, height: props.height }} />
      <img className={` mobile ${props.classname}`} alt="pull quote" src={props.mobileImage} style={{ width: props.width, height: props.height }} />
    </section>
  );
}
